export default __webpack_public_path__ + "static/media/page_first_visit.1ff18b35.svg";